import { Instagram, Facebook } from "lucide-react";
import { useQuery } from 'react-query';
import { getNavigationItems } from '@/api/navigationService';

const Footer = () => {
  const { data: col1Links = [] } = useQuery('nav-footer-col1', () => getNavigationItems('footer_col1'));
  const { data: col2Links = [] } = useQuery('nav-footer-col2', () => getNavigationItems('footer_col2'));
  const { data: legalLinks = [] } = useQuery('nav-footer-legal', () => getNavigationItems('footer_legal'));

  return (
    <footer className="bg-black" style={{ fontFamily: "'Manrope', sans-serif" }}>
      {/* Main footer content */}
      <div className="max-w-[1400px] mx-auto px-8 md:px-12 lg:px-16 pt-20 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">

          {/* Col 1: Tagline */}
          <div className="md:col-span-4">
            <h2 className="text-white text-3xl md:text-4xl font-medium leading-[1.2] tracking-tight">
              Prestaties op het
              <br />
              <span className="relative inline-block mt-5">
                <span
                  className="absolute inset-0 bg-[#B1A06D]"
                  style={{ transform: 'skewX(-4deg) rotate(-2deg)', borderRadius: '4px' }}
                />
                <span className="relative z-10 text-black font-semibold px-4 py-1 inline-block">
                  hoogste niveau
                </span>
              </span>
            </h2>
          </div>

          {/* Col 2: Navigation links with arrows */}
          <div className="md:col-span-3">
            <ul className="space-y-4">
              {col1Links.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.url}
                    target={link.isExternal ? '_blank' : undefined}
                    rel={link.isExternal ? 'noopener noreferrer' : undefined}
                    className="text-white text-sm hover:text-[#B1A06D] transition-colors flex items-center gap-3 group"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-[#B1A06D] group-hover:scale-125 transition-transform" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Info links */}
          <div className="md:col-span-2">
            <ul className="space-y-3">
              {col2Links.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.url}
                    target={link.isExternal ? '_blank' : undefined}
                    rel={link.isExternal ? 'noopener noreferrer' : undefined}
                    className="text-white/60 text-sm hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Contact + socials */}
          <div className="md:col-span-3">
            <div className="space-y-3">
              <p className="text-white/60 text-sm">
                Netwerk 12 A
                <br />
                1446 WK Purmerend
              </p>
              <a
                href="mailto:info@vermado.nl"
                className="text-white text-sm underline underline-offset-4 decoration-white/30 hover:decoration-white transition-colors block"
              >
                info@vermado.nl
              </a>
              <a
                href="tel:+31627225807"
                className="text-white text-sm underline underline-offset-4 decoration-white/30 hover:decoration-white transition-colors block"
              >
                +31 6 27225807
              </a>
              {/* Social icons */}
              <div className="flex items-center gap-3 pt-3">
                <a
                  href="https://www.instagram.com/vermado.nl/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:border-white/50 transition-colors"
                >
                  <Instagram className="w-4 h-4 text-white" />
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:border-white/50 transition-colors"
                >
                  <Facebook className="w-4 h-4 text-white" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-8 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Left: logo + copyright */}
          <div className="flex items-center gap-4">
            <img
              src="/lovable-uploads/f0397fdb-65b1-425f-a824-0229bd3e12d4.png"
              alt="Vermado"
              className="h-6 w-auto opacity-70"
            />
            <span className="text-white/30 text-xs">
              © {new Date().getFullYear()} Vermado
            </span>
          </div>

          {/* Right: legal links */}
          <div className="flex items-center gap-6 text-xs text-white/30">
            {legalLinks.map((link) => (
              <a
                key={link.id}
                href={link.url}
                target={link.isExternal ? '_blank' : undefined}
                rel={link.isExternal ? 'noopener noreferrer' : undefined}
                className="hover:text-white/60 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
